/**
 * Scroll reveals and number count-ups for the Great Stone Dragon sections.
 *
 * - Elements with [data-reveal] fade/slide in when they enter the viewport.
 * - Elements with [data-count] count up from zero ("3,000+", "48hr"...) the first time they are seen.
 *
 * The inline script in theme.liquid adds `gsd-motion` to <html> (never for reduced-motion visitors or
 * inside the theme editor). If this file fails to load, that script removes the class again after a
 * few seconds so content can never stay hidden.
 */
(() => {
  const root = document.documentElement;
  window.gsdMotionReady = true;

  if (!root.classList.contains('gsd-motion') || !('IntersectionObserver' in window)) {
    root.classList.remove('gsd-motion');
    return;
  }

  const formatCount = (value, useCommas) => (useCommas ? value.toLocaleString('en-US') : String(value));

  const countUp = (element) => {
    const original = element.textContent.trim();
    const match = original.match(/^(\d[\d,]*)(.*)$/);
    if (!match) return;

    const target = parseInt(match[1].replace(/,/g, ''), 10);
    const useCommas = match[1].includes(',');
    const suffix = match[2];
    const duration = 1400;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = formatCount(Math.round(target * eased), useCommas) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
      else element.textContent = original;
    };

    element.textContent = formatCount(0, useCommas) + suffix;
    requestAnimationFrame(tick);
  };

  const reveal = (element) => {
    element.classList.add('is-visible');
    element.addEventListener(
      'transitionend',
      (event) => {
        if (event.propertyName === 'opacity') element.classList.add('is-done');
      },
      { once: true }
    );
    if (element.hasAttribute('data-count')) countUp(element);
    element.querySelectorAll('[data-count]').forEach(countUp);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );

  document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));
})();
